import { ref, onMounted, onBeforeUnmount } from 'vue';
import { animate, set } from 'animejs';
import { useCommonData } from '@/hooks';

export function useSlideFade(elRef, options = {}) {
	const {
		offset = 20,
		showDuration = 400,
		hideDuration = 400,
		showEasing = 'easeOutCubic',
		hideEasing = 'easeInCubic'
	} = options;

	const { viewInIframe } = useCommonData();

	let animation = null;
	const visible = ref(false);

	// 定义初始帧
	const init = () => {
		if (viewInIframe.value) return;
		if (!elRef.value) return;
		set(elRef.value, {
			opacity: 0,
			translateY: -offset
		});
	};

	const show = () => {
		if (!elRef.value || visible.value) return;
		animation?.pause();
		animation = animate(elRef.value, {
			opacity: [0, 1],
			translateY: [-offset, 0],
			duration: showDuration,
			easing: showEasing,
			begin: () => {
				visible.value = true;
			}
		});
	};

	const hide = () => {
		if (!elRef.value || !visible.value) return;
		animation?.pause();
		animation = animate(elRef.value, {
			opacity: [1, 0],
			translateY: [0, -offset],
			duration: hideDuration,
			easing: hideEasing,
			complete: () => {
				visible.value = false;
			}
		});
	};

	onMounted(init);
	onBeforeUnmount(() => animation?.pause());

	return {
		show,
		hide,
		visible
	};
}
